import React, { useState, useEffect } from "react";
import { Avatar, Box, Grid, Typography } from "@mui/material";
// import TimeLineInfo from "./timeline-info";
import { getAvatarColor, TICKET_STAGES } from "../../utils/constants";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import { HTTP_METHODS, plainApi } from "../../utils/http-service";

import { Icon } from "@iconify/react";
import { HOSTNAME, REST_URLS } from "../../utils/endpoints";
import TicketFiles from "../../pages/admin/ticket-details-v2/ticket-files";
import moment from "moment";
const ViewAttachments = ({
  ticketDetails,
  openForm,
  loadData,
  timeline,
  setViewComplaint,
}) => {
  const [showAllComments, setShowAllComments] = useState(false);
  const [commentTimeline, setCommentTimeline] = useState([]);
  const handleShowAllComments = () => {
    setShowAllComments(true);
  };

  const getCommentList = () => {
    plainApi(
      HTTP_METHODS.GET,
      `${HOSTNAME}${REST_URLS.OEM_COMMENT}/${ticketDetails.id}`
    )
      .then((res) => {
        if (!res.message) {
          setCommentTimeline(res);
        }
      })
      .catch((err) => console.error(err));
  };
  const commentsToShow = showAllComments
    ? commentTimeline
    : commentTimeline.slice(0, 3); // Show only the first two comments

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    getCommentList();
  }, []);

  return (
    <div>
      <Grid container spacing={2}>
        <Grid item md={12} xs={12} className="page-load">
          <div
            className="form-con hide-scrollbar"
            style={{ maxHeight: "70vh" }}
          >
            <p className="form-header">Comments</p>
            <div className="gray-bg-con">
              <Icon
                icon="iconamoon:comment-dots-duotone"
                width="2rem"
                height="2rem"
                style={{ color: "#001a53", marginRight: "15px" }}
              />
              <p>Comments</p>
            </div>

            {commentsToShow.length > 0 ? (
              commentsToShow.map((line, index) => {
                const name = line?.createdBy?.name;
                return (
                  <div key={index}>
                    <div className="comment-con">
                      <Avatar
                        sx={{
                          bgcolor: getAvatarColor(name[0]),
                          marginRight: 2,
                        }}
                        title={name}
                      >
                        <Box sx={{ marginTop: "1px", marginLeft: "1px" }}>
                          {name[0].toUpperCase()}
                        </Box>
                      </Avatar>
                      <div>
                        <p className="primary-text">{line.comment}</p>
                        <p style={{ color: "#1B1F26B8", marginTop: "5px" }}>
                          added on {moment(line.createdAt).format("DD/MM/YYYY")}
                        </p>
                      </div>
                    </div>
                  </div>
                );
              })
            ) : (
              <Typography
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  mt: 5,
                  mb: 10,
                }}
              >
                No Comments
              </Typography>
            )}

            {commentTimeline.length > 3 && !showAllComments && (
              <div onClick={handleShowAllComments} className=" load-more-btn">
                Load More
              </div>
            )}
          </div>
        </Grid>
      </Grid>
      {/* <Grid container className="page-load">
        <Grid item md={12}>
          <TimeLineInfo
            ticketDetails={ticketDetails}
            timeline={timeline}
            openForm={() => setViewComplaint(true)}
            onDateChange={loadData}
            loadData={loadData}
          />
        </Grid>
      </Grid> */}
    </div>
  );
};

export default ViewAttachments;
